<template>
  <FormModal title="Edit Language" :endpoint="endpoint" method="PUT" :data="data" v-bind="$attrs" @success="success">
    <InputGroup label="Name" name="name">
      <TextInput v-model="data.name" placeholder="English" />
    </InputGroup>

    <InputGroup label="Alpha2" name="alpha2">
      <TextInput v-model="data.alpha2" placeholder="us" />
    </InputGroup>

    <InputGroup label="User Profile Enabled" name="user_profile_enabled">
      <ToggleSwitch v-model="data.user_profile_enabled" label="Allow users to select this language in their profile" />
    </InputGroup>
  </FormModal>
</template>

<script>
import { EditModalMixin } from "@syntax51/app-kit"

export default {
  mixins: [EditModalMixin],
  data: () => ({
    data: {
      alpha2: null,
      name: null,
      user_profile_enabled: null
    }
  }),
  methods: {
    success(result) {
      this.$notification.success(`Language **${this.data.name}** successfully updated.`)
      this.$emit("close", result)
    }
  }
}
</script>
